import { render, staticRenderFns } from "./MarketPlace.vue?vue&type=template&id=ff29ed92&scoped=true"
import script from "./MarketPlace.vue?vue&type=script&lang=js"
export * from "./MarketPlace.vue?vue&type=script&lang=js"
import style0 from "./MarketPlace.vue?vue&type=style&index=0&id=ff29ed92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff29ed92",
  null
  
)

export default component.exports